
export function parcelCanShip(width: number | null | undefined, height: number | null | undefined, depth: number | null | undefined): boolean | null {
  if (width == null) return null
  if (height == null) return null
  if (depth == null) return null

  let dimensions: number[] = [width, height, depth]
  dimensions = dimensions.sort(function (a, b) { return b - a })
  const max = dimensions[0]
  const mid = dimensions[1]
  const min = dimensions[2]

  //Puntoposte / Poste Locker
  if (max<=56 && mid<=37 && min <=36) return true

  //Poste Uffici Postali
  if (max<=100 && max+mid+min<=150) return true

  //TNT
  if (max<=50 && mid<=50 && min<=50) return true

  //Primaedicola
  if (max<=100 && max+mid+min<=200) return true

  //BRT
  if (max<=100 && (max+mid+min)/1000000 <=0.2) return true

  //UPS
  if (max<=97 && (mid+min)*2+max <=300) return true

  return false
}
